import { initializeApp } from "firebase/app";
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
  OAuthProvider,
  browserLocalPersistence,
  setPersistence,
} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

/**
 * Las claves web de Firebase son públicas por diseño: identifican al proyecto,
 * no autorizan nada. Lo que protege los datos son las reglas de Firestore y la
 * validación en las Cloud Functions.
 */
const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  /*
   * Sin esto, Analytics no arranca aunque el proyecto lo tenga habilitado.
   * Puede faltar --en los emuladores no aplica-- y entonces la analitica
   * simplemente no se enciende, que es el comportamiento correcto.
   */
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

if (!config.projectId) {
  throw new Error("Falta la configuración de Firebase. Revisa el archivo .env del modo activo.");
}

export const app = initializeApp(config);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");

void setPersistence(auth, browserLocalPersistence);

if (import.meta.env.VITE_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export const proveedorGoogle = new GoogleAuthProvider();
export const proveedorApple = new OAuthProvider("apple.com");
proveedorApple.addScope("email");
proveedorApple.addScope("name");
